import { IS_RUNTIME_FEDERATION } from "../../constants/environment";
import { registry } from "../../../configs/registry";
import { getLazyRuntimeApplicationComponent } from "../../federation/runtime";
import { getLazyRemoteApplicationComponent } from "../../federation/build";
export const createRoutes = () => {
    return registry.getApplicationByPath().map(([path, application]) => {
        const { id, urls, authorization } = application;
        return {
            id,
            path,
            authorization,
            RemoteComponent: IS_RUNTIME_FEDERATION
                ? getLazyRuntimeApplicationComponent(application)
                : getLazyRemoteApplicationComponent(id, urls.client),
        };
    });
};
